(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener("click", function(e) {
    let trigger = e.target.closest("[data-drawer]");
    let backdrop = document.getElementById("drawer-backdrop");
    // Open drawer
    if (trigger) {
        e.preventDefault();
        let drawerId = trigger.getAttribute("data-drawer");
        let drawer = document.getElementById(drawerId);
        if (drawer) {
          drawer.classList.add("open");
          backdrop.classList.add("active");
        }
    }
    // Close drawer on close button or backdrop click
    if (e.target.closest("[data-drawer-close]") || e.target === backdrop) {
        closeDrawer(); 
    }
});

// Close drawer on ESC key
document.addEventListener("keydown", function(e) {
  if (e.key === "Escape") {
    closeDrawer();
  }
});

function closeDrawer() {
    document.querySelectorAll(".drawer").forEach(d => d.classList.remove("open"));
    document.getElementById("drawer-backdrop").classList.remove("active");
    document.querySelectorAll(".pro-shipping-info-link").forEach(el => el.classList.remove("active")); /* For product tabs */
}

document.addEventListener("DOMContentLoaded", function() {
  const tabs = document.querySelectorAll(".drawer-tab");
  const contents = document.querySelectorAll(".drawer-tab-content");

  tabs.forEach(tab => {
    tab.addEventListener("click", function() {
      // remove active from all tabs
      tabs.forEach(t => t.classList.remove("active"));
      this.classList.add("active");

      // hide all contents
      contents.forEach(c => c.style.display = "none");

      // show matched content
      const target = this.getAttribute("data-tab");
      document.getElementById("tab-" + target).style.display = "block";
    });
  });
});

document.querySelectorAll('.location-drawer-link').forEach(element => {
  element.addEventListener("click", function() {
    document.querySelector('[data-tab="location"]').click();
  });
});

document.querySelectorAll('.lang-drawer-link').forEach(element => {
  element.addEventListener("click", function() {
    document.querySelector('[data-tab="language"]').click();
  });
});


  } catch(e) { console.error(e); }
})();
})();
